import * as Scrivito from "scrivito";
import { create } from "zustand";
import { getLanguage } from "./globalStore";

const localAttrNames: string[] = [
  "localsAE",
  "localsFJ",
  "localsKO",
  "localsPT",
  "localsUZ",
];

export type TranslationsMap = Record<string, string>;

type LocalsObj = Record<string, TranslationsMap>;

type Locals = Record<string, TranslationsMap>;

type UseLocalsStoreState = {
  locals: Locals;
  init: () => Promise<void>;
};

const useLocalsStore = create<UseLocalsStoreState>((set) => ({
  locals: {},
  init: async () => {
    const lang = getLanguage();
    const localsObj = await Scrivito.load(() =>
      Scrivito.Obj.where("_objClass", "equals", "Locals").first(),
    );

    const locals: LocalsObj = {};

    if (!localsObj) {
      return;
    }

    localAttrNames.forEach((name) => {
      const localsData = localsObj.get(name) as string;
      const parsedLocalsData = JSON.parse(localsData) as LocalsObj;
      const translations: TranslationsMap = parsedLocalsData?.[lang] || {};
      locals[name] = translations;
    });

    set({ locals });
  },
}));

export const useLocals = () => useLocalsStore((state) => state.locals);
export const initLocalsStore = async () => {
  await useLocalsStore.getState().init();
};

export const getLocals = () => useLocalsStore.getState().locals;
